import * as Yup from 'yup';

export const locationSchema = [
  {
    name: 'locationName',
    initialValue: '',
    validation: Yup.string().required('Location name is required.'),
    input: {
      placeholder: 'Location name',
      className: 'location-name',
      type: 'input',
    },
  },
  {
    name: 'locationAddress',
    initialValue: '',
    validation: Yup.string().required('Location adddress is required.'),
    input: {
      placeholder: 'Location address',
      className: 'location-address',
      type: 'input',
      as: 'select',
    },
  },
  {
    name: 'currentLocation',
    initialValue: '',
    validation: Yup.string().required('Company name is required.'),
    input: {
      placeholder: 'Current Location',
      className: 'current-location',
      label: 'Current Location',
      type: 'checkbox',
    },
  },
];
